<div class="position-relative text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Import {{ this.data.importType }}</h4>
    <i style="z-index: 1"
       class="bi bi-x-lg text-danger"
       color="warn"
       (click)="onClose()"
       title="Close"></i>
  </div>
  <div class="modal-body">
    <p>Verify below details before importing {{ this.data.importType.toLowerCase() }}.</p>
    <ol>
      <li>File should be a .csv file</li>
      <li>
        File must contain following data of nodes : <br />
        {{ this.data.requiredParams }}
        <!-- firstName, lastName, emailId, userName, password, userRole, deployment,
        publicKey -->
      </li>
      <li>{{ this.data.uniqueFields }} must be unique for each entry.</li>
      <li>
        Consider following connector type values for each type :
        <br />
        <ul>
          <li>0 => Microsoft Azure</li>
          <li>1 => Amazon Web Services</li>
          <li>2 => Oracle Cloud</li>
          <li>3 => Google Cloud Platform</li>
          <li>4 => Open Stack</li>
          <li>6 => Kvm Virtualization</li>
        </ul>
      </li>
    </ol>
    <div>
      <input type="file"
             class="file-input d-none"
             (change)="onFileSelected($event)"
             (click)="onFileChange()"
             accept=".csv"
             #fileUpload />

      <div class="file-upload">
        <label for="" *ngIf="!fileName">Upload a file.</label>
        <label for="" *ngIf="fileName">
          File uploaded :
          <strong>{{ fileName }} ( {{ importArray.length }} {{ this.data.importType }} found. )</strong>
        </label>
        <button mat-mini-fab
                color="primary"
                class="upload-btn ms-1"
                (click)="fileUpload.click()">
          <i class="bi bi-paperclip"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="flex-grow-1">
      <button type="button" title="Download sample template structure of csv file" class="btn btn-sm btn-primary float-start" style="background-color: var(--s-primary-color)!important;" (click)="downloadTemplate()">
        Sample template <i class="bi bi-arrow-down-circle color-primary"></i>
      </button>
    </div>
    <button type="button" class="btn btn-outline-secondary" style="z-index: 1" (click)="onClose()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" [disabled]="importArray.length > 0 ? false : true" (click)="onSubmit()">
      Submit
    </button>
  </div>
  <ngx-spinner bdColor="rgba(0,0,0,0)"
               name="bulkAddUser"
               size="default"
               zIndex="1"
               color="var(--s-primary-color)"
               type="ball-spin"
               [fullScreen]="false"><p class="pleaseWait">Adding {{ this.data.importType.toLowerCase() }} please wait ...</p></ngx-spinner>
</div>
